<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      Made by
      <b-link
        class="ml-25"
        href="http://www.sanniomatica.it/"
        target="_blank"
      >SANNIOMATICA S.R.L.</b-link>
      <span class="d-none d-sm-inline-block"> - "Business &amp; Technology Innovation"</span>
    </span>

    <span class="float-md-right d-none d-md-block" />
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
